import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import { useModal } from "@/hooks";
import config from "@/lib/config";
import styles from "@/styles/ShareModal.module.scss";
import { useCallback, useEffect, useState } from "react";
import {
  FacebookIcon,
  FacebookShareButton,
  LineIcon,
  LineShareButton,
} from "react-share";
import Check from "../../svgs/icon_check_green.svg";
import Copy from "../../svgs/icon_copy.svg";
import IconShare from "../../svgs/icon_share.svg";
import XIcon from "../../svgs/x_logo_share_black.svg";
import XShareButton from "./XShareButton";

function ModalShare({ title }) {
  const url = window.location.href;
  const serviceName = config.serviceName.vod;
  // 空白を消して文字列を詰める処理↓
  const hashtag = serviceName.replace(/\s/g, "");
  const shareMessage = `${serviceName}で${title}が配信中!`;
  const [copyFlag, setCopyFlag] = useState(false);

  const copyTextToClipboard = useCallback(() => {
    navigator.clipboard.writeText(url).then(
      function () {
        console.log("success copied");
        setCopyFlag(true);
      },
      function (err) {
        console.error("couldent copy");
      }
    );
  }, [url]);
  //コピーフラグがtrueになったら３秒後にflaseに戻す
  useEffect(() => {
    let timeoutId;
    if (copyFlag === true) {
      timeoutId = setTimeout(() => {
        console.log("clear flag");
        setCopyFlag(false);
      }, 3000);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [copyFlag]);

  return (
    <div className={styles.container}>
      <div className={styles.title}>共有</div>
      <div className={styles.shareButtons}>
        <div className={styles.shareButton}>
          <XShareButton text={shareMessage} url={url} hashtags={[hashtag]}>
            <XIcon className={styles.XIcon}></XIcon>
          </XShareButton>
          <div className={styles.snsName}>X（旧Twitter）</div>
        </div>

        <div className={styles.shareButton}>
          <FacebookShareButton url={url}>
            <FacebookIcon size={60} round />
          </FacebookShareButton>
          <div className={styles.snsName}>Facebook</div>
        </div>

        <div className={styles.shareButton}>
          <LineShareButton url={url} title={shareMessage}>
            <LineIcon size={60} round />
          </LineShareButton>
          <div className={styles.snsName}>LINE</div>
        </div>
      </div>
      <div className={styles.urlCopy}>
        <input
          className={styles.urlSpace}
          type="text"
          value={url}
          readOnly
          onFocus={(e) => {
            e.target.select();
          }}
        />
        <a className={styles.copyButton} onClick={copyTextToClipboard}>
          {!copyFlag && <Copy />}
          {copyFlag && <Check />}
        </a>
      </div>
    </div>
  );
}

export default function ShareButton(props) {
  const { title, ...buttonProps } = props;
  const { showModal } = useModal();
  const handleClick = useCallback(() => {
    showModal(<ModalShare title={title} />, {
      closeButton: false,
      outerAreaClose: true,
      style: ["small", "maxWidthS", "mashEdge"],
    });
  }, []);

  return (
    //シェアボタンはお気に入りボタンと同じcssのためfavBtn styleを使っている
    <ButtonMultiClick
      title="シェア"
      {...buttonProps}
      favBtn
      withIcon
      hoverAnimation
      onClick={handleClick}
    >
      <span>
        <IconShare />
      </span>
    </ButtonMultiClick>
  );
}
